var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('client-only',[_c('swiper',{ref:"text-slider",staticClass:"text-slider",class:_vm.header_slider_classes,attrs:{"options":_vm.sliderSettings}},_vm._l((_vm.block),function(slide,i){return _c('swiper-slide',{key:i},[(slide.text)?_c('span',{staticClass:"text-slider__headline",class:slide.headline_color
            ? _vm.text_font +
              ' with-text-gradient gradient-' +
              slide.headline_color
            : _vm.text_font + ' with-text-gradient gradient-green'},[_c('strong',[_vm._v(_vm._s(slide.text))])]):_vm._e()])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }